export class er{
    key: string;
    mensaje: string;
}